import * as React from 'react';

import { Box } from '@mui/material';

interface IFormHeader {
  children: React.ReactNode;
}

function FormHeader({ children }: IFormHeader) {
  return (
    <Box display="flex">
      {children}
    </Box>
  );
}

export default FormHeader;
